<template>
  <div class="warp-berita overflow-x-hidden">
      <HeroSection />
      <VisiMisiSection/>
      <BeritaTerbaruSection/>
      <InfoSipenmaru/>
  </div>
</template>

<script>
import BeritaTerbaruSection from '@/components/simakad/berita/BeritaTerbaruSection.vue';
import HeroSection from '@/components/simakad/berita/HeroSection.vue';
import InfoSipenmaru from '@/components/simakad/berita/InfoSipenmaru.vue';
import VisiMisiSection from '@/components/simakad/berita/VisiMisiSection.vue';


export default {
    name: 'SimakadBerita',
    components: {
        HeroSection,
        VisiMisiSection,
        BeritaTerbaruSection,
        InfoSipenmaru
    },

  mounted() {
    console.log('SpmiHome.vue has been mounted');
  },
  beforeUnmount() {
    console.log('❌ SpmiHome.vue is being destroyed');
  }
}
</script>
<style scoped lang="scss">

</style>
